// API URL - Auto-detect based on environment
// In development (localhost:3000), use local backend
// In production, use Azure backend
const hostname = window.location.hostname;
const isLocal = hostname === 'localhost';
const FIRST_PARTY_HOSTS = [
  'ofself.ai', 'app.ofself.ai', 'nucleus.ofself.ai', 'cosm.ofself.ai', 'developer.ofself.ai',
  'ofself.com', 'app.ofself.com', 'nucleus.ofself.com', 'cosm.ofself.com', 'developer.ofself.com',
];
const isFirstParty = isLocal || FIRST_PARTY_HOSTS.includes(hostname);

export const API_BASE = import.meta.env.VITE_API_URL ||
  (isLocal ? '/api/v1' : 'https://api.ofself.com/api/v1');

// First-Party App Key - Required for auth endpoints (login, register, refresh)
// This enforces Paradigm's data sovereignty model: only official apps can use JWT auth.
// Third-party apps must use API keys with privacy realms / exposure profiles.
export const FIRST_PARTY_APP_KEY = import.meta.env.VITE_FIRST_PARTY_KEY ||
  (isFirstParty
    ? 'dev-first-party-key-change-in-production'  // Dev key - matches backend config.py default
    : '');  // Production key must be set via REACT_APP_FIRST_PARTY_KEY
